import {
  AA_NON_TEXT,
  accentTextOnCanvas,
  liftToContrast,
  mix,
  darkPalettes,
  lightPalettes,
  onFilled,
  withFocusRing,
  type PaletteProps,
  type ThemeName
} from 'pixelize-design-library';

import { buildBrandScale } from './colorRamp';

/** Same accent as the auth pages (see modules/auth/theme/authBrandPalette.ts), rolled out app-wide. */
const APP_ACCENT_500 = '#3a75cf';
const AA_NORMAL_TEXT = 4.5;
const ACTIVE_ROW_WHITE = 0.24;

// Mirrors the library's sidebar builder so the active row follows the app accent, not the brand.
function withSidebarAccent(
  base: PaletteProps,
  lightPrimary: PaletteProps['primary']
): PaletteProps['sidebar'] {
  const surface = mix(base.sidebar.background[500], '#ffffff', ACTIVE_ROW_WHITE);
  return {
    ...base.sidebar,
    activeIcon: liftToContrast(lightPrimary[300], surface, AA_NON_TEXT),
    activeLabel: liftToContrast(lightPrimary[100], surface, AA_NORMAL_TEXT)
  };
}

function withAppAccent(
  base: PaletteProps,
  towardLow: string,
  towardHigh: string,
  lightPrimary: PaletteProps['primary']
): PaletteProps {
  const primary = buildBrandScale(APP_ACCENT_500, towardLow, towardHigh);
  return withFocusRing({
    ...base,
    primary,
    sidebar: withSidebarAccent(base, lightPrimary),
    accentText: accentTextOnCanvas(primary, base.backgroundColor.light),
    onPrimary: onFilled(primary[500], base.white, base.black)
  });
}

export function appAccentPalette(brand: ThemeName): { light: PaletteProps; dark: PaletteProps } {
  const light = lightPalettes[brand];
  const dark = darkPalettes[brand];
  const lightPrimary = buildBrandScale(APP_ACCENT_500, light.white, light.black);
  return {
    light: withAppAccent(light, light.white, light.black, lightPrimary),
    dark: withAppAccent(dark, dark.black, dark.white, lightPrimary)
  };
}
